<template>
  <div class="dashboard-editor-container">
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item title="1、功能说明" name="1">
        <div><el-image :src="m1"></el-image></div>
      </el-collapse-item>

      <el-collapse-item title="2、单条添加" name="2">
        <div><el-image :src="m2"></el-image></div>
      </el-collapse-item>

      <el-collapse-item title="3、单条修改" name="3">
        <div><el-image :src="m3"></el-image></div>
      </el-collapse-item>

      <el-collapse-item title="4、批量导入" name="4">
        <div><el-image :src="m4"></el-image></div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import m1 from '@/assets/manual/1.png'
import m2 from '@/assets/manual/2.png'
import m3 from '@/assets/manual/3.png'
import m4 from '@/assets/manual/4.png'
export default {
  name: 'dashboard',
  data() {
    return {
      m1,m2,m3,m4,
      activeName: '1'
      }
    },
  created(){
    
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .panel-group {
    margin-top: 18px;
    .card-panel-col {
      margin-bottom: 32px;
    }
    .card-panel {
      height: 108px;
      cursor: pointer;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      color: #666;
      background: #fff;
      box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
      border-color: rgba(0, 0, 0, .05);
      &:hover {
        .card-panel-icon-wrapper {
          color: #fff;
        }
        .icon-people {
          background: #40c9c6;
        }
        .icon-message {
          background: #36a3f7;
        }
        .icon-money {
          background: #f4516c;
        }
        .icon-shoppingCard {
          background: #34bfa3
        }
      }
      .icon-people {
        color: #40c9c6;
      }
      .icon-message {
        color: #36a3f7;
      }
      .icon-money {
        color: #f4516c;
      }
      .icon-shoppingCard {
        color: #34bfa3
      }
      .card-panel-icon-wrapper {
        float: left;
        margin: 14px 0 0 14px;
        padding: 16px;
        transition: all 0.38s ease-out;
        border-radius: 6px;
      }
      .card-panel-icon {
        float: left;
        font-size: 48px;
      }
      .card-panel-description {
        width:120px;
        float: right;
        font-weight: bold;
        margin: 26px;
        margin-left: 0px;
        .card-panel-text {
          line-height: 18px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 16px;
          margin-bottom: 12px;
        }
        .card-panel-num {
          font-size: 20px;
        }
      }
    }
  }

  .dashboard-editor-container {
  padding: 20px;
  background-color: rgb(240, 242, 245);
  min-height: calc(100vh - 84px);

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }

  .component-item {
    min-height: 100px;
  }
  .divider {
    font-size:20px;
    background-color: rgb(240, 242, 245);
  }

  .el-divider__text {
    color:blue;
      font-size:20px;
      background-color: rgb(240, 242, 245);
  }
}

</style>